// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/trip_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_model_path } from "../model/core/model_path_pb";
import { file_proto_model_preferences_preferences } from "../model/preferences/preferences_pb";
import { file_proto_model_trip_trip } from "../model/trip/trip_pb";

/**
 * Describes the file proto/service/trip_service.proto.
 */
export const file_proto_service_trip_service = /*@__PURE__*/
  fileDesc("CiBwcm90by9zZXJ2aWNlL3RyaXBfc2VydmljZS5wcm90bxIGY2FybWVuIlQKEUNyZWF0ZVRyaXBSZXF1ZXN0EiMKCXVzZXJfcGF0aBgBIAEoCzIQLmNhcm1lbi5Vc2VyUGF0aBIaCgR0cmlwGAIgASgLMgwuY2FybWVuLlRyaXAiMAoSQ3JlYXRlVHJpcFJlc3BvbnNlEhoKBHRyaXAYASABKAsyDC5jYXJtZW4uVHJpcCI1Cg5HZXRUcmlwUmVxdWVzdBIjCgl0cmlwX3BhdGgYASABKAsyEC5jYXJtZW4uVHJpcFBhdGgiLQoPR2V0VHJpcFJlc3BvbnNlEhoKBHRyaXAYASABKAsyDC5jYXJtZW4uVHJpcCJeChBMaXN0VHJpcHNSZXF1ZXN0EiMKCXVzZXJfcGF0aBgBIAEoCzIQLmNhcm1lbi5Vc2VyUGF0aBIRCglwYWdlX3NpemUYAiABKAUSEgoKcGFnZV90b2tlbhgDIAEoCSJJChFMaXN0VHJpcHNSZXNwb25zZRIbCgV0cmlwcxgBIAMoCzIMLmNhcm1lbi5UcmlwEhcKD25leHRfcGFnZV90b2tlbhgCIAEoCSKFAQoRVXBkYXRlVHJpcFJlcXVlc3QSIwoJdHJpcF9wYXRoGAEgASgLMhAuY2FybWVuLlRyaXBQYXRoEhoKBHRyaXAYAiABKAsyDC5jYXJtZW4uVHJpcBIvCgt1cGRhdGVfbWFzaxgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2siMAoSVXBkYXRlVHJpcFJlc3BvbnNlEhoKBHRyaXAYASABKAsyDC5jYXJtZW4uVHJpcCI4ChFEZWxldGVUcmlwUmVxdWVzdBIjCgl0cmlwX3BhdGgYASABKAsyEC5jYXJtZW4uVHJpcFBhdGgiJQoSRGVsZXRlVHJpcFJlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgibQocVXBkYXRlVHJpcFByZWZlcmVuY2VzUmVxdWVzdBIjCgl0cmlwX3BhdGgYASABKAsyEC5jYXJtZW4uVHJpcFBhdGgSKAoLcHJlZmVyZW5jZXMYAiABKAsyEy5jYXJtZW4uUHJlZmVyZW5jZXMiSQodVXBkYXRlVHJpcFByZWZlcmVuY2VzUmVzcG9uc2USKAoLcHJlZmVyZW5jZXMYASABKAsyEy5jYXJtZW4uUHJlZmVyZW5jZXMibAobTWVyZ2VUcmlwUHJlZmVyZW5jZXNSZXF1ZXN0EiMKCXRyaXBfcGF0aBgBIAEoCzIQLmNhcm1lbi5UcmlwUGF0aBIoCgtwcmVmZXJlbmNlcxgCIAEoCzITLmNhcm1lbi5QcmVmZXJlbmNlcyJIChxNZXJnZVRyaXBQcmVmZXJlbmNlc1Jlc3BvbnNlEigKC3ByZWZlcmVuY2VzGAEgASgLMhMuY2FybWVuLlByZWZlcmVuY2VzMqMECgtUcmlwU2VydmljZRJDCgpDcmVhdGVUcmlwEhkuY2FybWVuLkNyZWF0ZVRyaXBSZXF1ZXN0GhouY2FybWVuLkNyZWF0ZVRyaXBSZXNwb25zZRI6CgdHZXRUcmlwEhYuY2FybWVuLkdldFRyaXBSZXF1ZXN0GhcuY2FybWVuLkdldFRyaXBSZXNwb25zZRJACglMaXN0VHJpcHMSGC5jYXJtZW4uTGlzdFRyaXBzUmVxdWVzdBoZLmNhcm1lbi5MaXN0VHJpcHNSZXNwb25zZRJDCgpVcGRhdGVUcmlwEhkuY2FybWVuLlVwZGF0ZVRyaXBSZXF1ZXN0GhouY2FybWVuLlVwZGF0ZVRyaXBSZXNwb25zZRJDCgpEZWxldGVUcmlwEhkuY2FybWVuLkRlbGV0ZVRyaXBSZXF1ZXN0GhouY2FybWVuLkRlbGV0ZVRyaXBSZXNwb25zZRJkChVVcGRhdGVUcmlwUHJlZmVyZW5jZXMSJC5jYXJtZW4uVXBkYXRlVHJpcFByZWZlcmVuY2VzUmVxdWVzdBolLmNhcm1lbi5VcGRhdGVUcmlwUHJlZmVyZW5jZXNSZXNwb25zZRJhChRNZXJnZVRyaXBQcmVmZXJlbmNlcxIjLmNhcm1lbi5NZXJnZVRyaXBQcmVmZXJlbmNlc1JlcXVlc3QaJC5jYXJtZW4uTWVyZ2VUcmlwUHJlZmVyZW5jZXNSZXNwb25zZUIqWihnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9zZXJ2aWNlYgZwcm90bzM", [file_google_protobuf_field_mask, file_proto_model_core_model_path, file_proto_model_preferences_preferences, file_proto_model_trip_trip]);

/**
 * Describes the message carmen.CreateTripRequest.
 * Use `create(CreateTripRequestSchema)` to create a new message.
 */
export const CreateTripRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 0);

/**
 * Describes the message carmen.CreateTripResponse.
 * Use `create(CreateTripResponseSchema)` to create a new message.
 */
export const CreateTripResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 1);

/**
 * Describes the message carmen.GetTripRequest.
 * Use `create(GetTripRequestSchema)` to create a new message.
 */
export const GetTripRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 2);

/**
 * Describes the message carmen.GetTripResponse.
 * Use `create(GetTripResponseSchema)` to create a new message.
 */
export const GetTripResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 3);

/**
 * Describes the message carmen.ListTripsRequest.
 * Use `create(ListTripsRequestSchema)` to create a new message.
 */
export const ListTripsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 4);

/**
 * Describes the message carmen.ListTripsResponse.
 * Use `create(ListTripsResponseSchema)` to create a new message.
 */
export const ListTripsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 5);

/**
 * Describes the message carmen.UpdateTripRequest.
 * Use `create(UpdateTripRequestSchema)` to create a new message.
 */
export const UpdateTripRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 6);

/**
 * Describes the message carmen.UpdateTripResponse.
 * Use `create(UpdateTripResponseSchema)` to create a new message.
 */
export const UpdateTripResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 7);

/**
 * Describes the message carmen.DeleteTripRequest.
 * Use `create(DeleteTripRequestSchema)` to create a new message.
 */
export const DeleteTripRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 8);

/**
 * Describes the message carmen.DeleteTripResponse.
 * Use `create(DeleteTripResponseSchema)` to create a new message.
 */
export const DeleteTripResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 9);

/**
 * Describes the message carmen.UpdateTripPreferencesRequest.
 * Use `create(UpdateTripPreferencesRequestSchema)` to create a new message.
 */
export const UpdateTripPreferencesRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 10);

/**
 * Describes the message carmen.UpdateTripPreferencesResponse.
 * Use `create(UpdateTripPreferencesResponseSchema)` to create a new message.
 */
export const UpdateTripPreferencesResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 11);

/**
 * Describes the message carmen.MergeTripPreferencesRequest.
 * Use `create(MergeTripPreferencesRequestSchema)` to create a new message.
 */
export const MergeTripPreferencesRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 12);

/**
 * Describes the message carmen.MergeTripPreferencesResponse.
 * Use `create(MergeTripPreferencesResponseSchema)` to create a new message.
 */
export const MergeTripPreferencesResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_trip_service, 13);

/**
 * TripService provides methods for managing trips
 *
 * @generated from service carmen.TripService
 */
export const TripService = /*@__PURE__*/
  serviceDesc(file_proto_service_trip_service, 0);

